"use client";

import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
const PageTitle = (props: any) => {
  const { title, description, cls } = props;
  return (
    <>
      <div
        className={`flex flex-wrap sm:flex-nowrap md:justify-evenly md:mx-auto md:w-auto ${cls}`}
      >
        <h1 className="text-scgreen w-[300px] md:w-[260px] p-4 pb-0">
          {title}
        </h1>
        <ReactMarkdown
          remarkPlugins={[remarkBreaks]}
          rehypePlugins={[rehypeRaw]}
          className="bdy-txt-3 w-full md:w-[65%] p-4 pt-2.5 pb-12"
        >
          {description?.replace(/\n/gi, "&nbsp; \n")}
        </ReactMarkdown>
      </div>
    </>
  );
};
export default PageTitle;
